import { styles } from './UiKitLoaderBase.styles';

type NativeElement = React.HTMLAttributes<HTMLDivElement>;

export interface UiKitLoaderBaseProps {
  viewType?: 'base' | 'overlay';
  show?: boolean;
  className?: string;
  onClick?: NativeElement['onClick'];
}

export function UiKitLoaderBase({
  viewType = 'base',
  show = true,
  className,
  onClick = (e) => e.stopPropagation()
}: UiKitLoaderBaseProps) {
  const slots = styles();

  if (!show) return null;

  return (
    <div
      className={slots.base({ className })}
      onClick={onClick}
    >
      {viewType === 'overlay' ? null : <div className={slots.loading()} />}
    </div>
  );
}
